import { gql } from "@apollo/client";

export const LOGIN_MUTATION = gql`
  mutation login($email: String!, $password: String!, $acceptAgreement: Boolean) {
    login(input: { email: $email, password: $password, acceptAgreement: $acceptAgreement }) {
      userID
      needAgreement
      tokens {
        accessToken
        refreshToken
      }
    }
  }
`;
